import React, { useMemo, useState,useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
const Display = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  
const user = JSON.parse(localStorage.getItem("authUser"));
  
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [inventoryItems, setinventoryItems] = useState([]);
 const [error, setError] = useState(null);
const [transfer, setTransfer] = useState(false);
const [currentQun, setCurrentQun] = useState(null);
 const toggleTransferModal = () => setTransfer(!transfer);

  const toggleModal = () => setModal(!modal);

    const fetchproductsData = async () => {
          try {
            setError(null);
            const response = await fetch(`${baseurl}/admin/products/products`);
            if (!response.ok) throw new Error("Network response was not ok");
            const data = await response.json();
            setinventoryItems(data);
          } catch (error) {
            setError(error.message);
          }
        };
      
        useEffect(() => {
          fetchproductsData();
        }, []);

  const handleEditClick = (product) => {
    setCurrentProduct(product);
    setIsEdit(true);
    toggleModal();
  };

   // For transfer reserved quantity model
  const handleTransferClick = (product) => {
    setCurrentProduct(product);
    toggleTransferModal();
    setCurrentQun(null);
  };

  const transferValidationSchema = Yup.object({
      currentQun: Yup.number()
        .required("Please enter a transfer quantity")
        .min(1, "Quantity must be at least 1")
        .max(
          currentProduct?.reserved_quantity || 0,
          "Cannot transfer more than available quantity"
        ),
    });

   const transferFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (currentProduct && currentProduct.id) || "",
      quantity: (currentProduct && currentProduct.reserved_quantity) || "0",
      totalStock: (currentProduct && currentProduct.total_stock) || "0",
      currentQun: (currentQun && currentQun) || "",
    },
    validationSchema: transferValidationSchema,
    onSubmit: async (values) =>  {
      const { currentQun,purchasePrice,selectedDate,id } = values;
        
            try {
              let response;
              
                // For add, make an API POST request
                response = await fetch(baseurl+'/admin/products/online-transfers', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    quantity: currentQun, 
                    purchase_price: 0, 
                    cdate: new Date(),
                    stock_type:'transfer',
                    product_id : id,
                    userid:user.id
                  }),
                });
               if (!response.ok) {
                  throw new Error("Error adding new user");
                }

                toast.success('Product Stock transfer successfully!', 'success');
                fetchproductsData();
              toggleTransferModal();
            } catch (error) {
              console.error(error);
              // Handle any errors, show an error message if needed
            }
      
    },
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (currentProduct && currentProduct.id) || "",
      productName: (currentProduct && currentProduct.productName) || "",
      quantity: (currentProduct && currentProduct.quantity) || "",
      price: (currentProduct && currentProduct.price) || "",
      status: (currentProduct && currentProduct.status) || "active",
    },
    validationSchema: Yup.object({
      productName: Yup.string().required("Please enter the Product name"),
      quantity: Yup.string().required("Please add quantity"),
      price: Yup.string().required("Please add price"),
      status: Yup.string().required("Please select the status"),
    }),
    onSubmit: (values) => {
      console.log("Updating product:", values);
      toggleModal();
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Product Name",
        accessor: "product_name",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Online Store Qty",
        accessor: "reserved_quantity",
        filterable: true,
        Cell: ({ value }) => {
          if (value === 0) {
            return <div className="text-danger fw-bold">Out of Stock</div>;
          } else if (value < 10) {
            return <div className="text-danger fw-bold">{value}</div>;
          } else {
            return <div>{value}</div>;
          }
        },
      },
      {
        Header: "Offline Store Qty",
        accessor: "total_stock",
        filterable: true,
        Cell: ({ value }) => {
          if (value === 0) {
            return <div className="text-danger fw-bold">Out of Stock</div>;
          } else if (value < 10) {
            return <div className="text-danger fw-bold">{value}</div>;
          } else {
            return <div>{value}</div>;
          }
        },
      },
      {
        Header: "Purchase Price (Per item)",
        accessor: "purchase_price",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">₹ {value}</div>,
      },
      {
        Header: "Status",
        accessor: "status",
        filterable: true,
        Cell: ({ value }) => {
          return (
            <Badge color={value === "Active" ? "success" : "danger"}>
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </Badge>
          );
        },
      },{
        Header: "Transfer",
        Cell: ({ row }) => {
                  return (
                    <Button
                      type="button"
                      color="success"
                      className="btn mb-2 me-2"
                     // style={{ width: "200px" }}
                      onClick={() => handleTransferClick(row.original)}
                    >
                      <i className="bx bx-transfer me-1"></i>
                     
                    </Button>
                  );
                },
      },

      
     /* {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleEditClick(row.original)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },*/
    ],
    []
  );

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Manage Inventory" breadcrumbItem="Online Store" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={inventoryItems}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Modal for Edit Display Products */}
          <Modal
            isOpen={modal}
            toggle={toggleModal}
            backdrop="static"
            keyboard={false}
          >
            <ModalHeader toggle={toggleModal} tag="h4">
              Edit Product
            </ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Product Name</Label>
                      <Input
                        name="productName"
                        type="text"
                        placeholder="Insert Product Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.productName || ""}
                        invalid={
                          formik.touched.productName &&
                          formik.errors.productName
                            ? true
                            : false
                        }
                      />
                      {formik.touched.productName &&
                      formik.errors.productName ? (
                        <FormFeedback type="invalid">
                          {formik.errors.productName}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Product Quantity</Label>
                      <Input
                        name="quantity"
                        type="number"
                        placeholder="Insert Product Quantity"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.quantity || ""}
                        invalid={
                          formik.touched.quantity && formik.errors.quantity
                            ? true
                            : false
                        }
                      />
                      {formik.touched.quantity && formik.errors.quantity ? (
                        <FormFeedback type="invalid">
                          {formik.errors.quantity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Product Price</Label>
                      <Input
                        name="price"
                        type="number"
                        placeholder="Insert Product Price"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.price || ""}
                        invalid={
                          formik.touched.price && formik.errors.price
                            ? true
                            : false
                        }
                      />
                      {formik.touched.price && formik.errors.price ? (
                        <FormFeedback type="invalid">
                          {formik.errors.price}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Status</Label>
                      <Input
                        name="status"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status || ""}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </Input>
                      {formik.touched.status && formik.errors.status ? (
                        <FormFeedback type="invalid">
                          {formik.errors.status}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        {isEdit ? "Update" : "Save"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
      {/* Modal for Transfer Reserved Products */}
                <Modal
                  isOpen={transfer}
                  toggle={toggleTransferModal}
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={toggleTransferModal} tag="h4">
                    Transfer to Offline Store Quantity
                  </ModalHeader>
                  <ModalBody>
                    <form onSubmit={transferFormik.handleSubmit}>
                      <Row>
                        <Col className="col-12">
                          <div className="mb-3">
                            <Label className="form-label">Online Store Quantity</Label>
                            <Input type="text"
                            name="quantity"
                            onChange={transferFormik.handleChange}
                              onBlur={transferFormik.handleBlur}
                              value={transferFormik.values.quantity || ""}
                              invalid={
                                transferFormik.touched.quantity && transferFormik.errors.quantity
                                  ? true
                                  : false }
                               disabled />
                          </div>
                          <div className="mb-3">
                            <Label className="form-label">Offline Store Quantity</Label>
                            <Input type="number" onChange={transferFormik.handleChange}
                              name="totalStock"
                              onBlur={transferFormik.handleBlur}
                              value={transferFormik.values.totalStock || ""}
                              invalid={
                                transferFormik.touched.totalStock && transferFormik.errors.totalStock
                                  ? true
                                  : false } disabled />
                          </div>
                          <div className="mb-3">
                            <Label className="form-label">Transfer to Offline Store Quantity</Label>
                            <Input
                              name="currentQun"
                              type="number"
                              placeholder="Insert Transfer Quantity"
                              onChange={transferFormik.handleChange}
                              onBlur={transferFormik.handleBlur}
                              value={transferFormik.values.currentQun || ""}
                              invalid={
                                transferFormik.touched.currentQun &&
                                transferFormik.errors.currentQun
                                  ? true
                                  : false
                              }
                            />
                            {transferFormik.touched.currentQun &&
                            transferFormik.errors.currentQun ? (
                              <FormFeedback type="invalid">
                                {transferFormik.errors.currentQun}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="text-end">
                            <Button type="submit" color="success">
                              Transfer
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </ModalBody>
                </Modal>
    </>
  );
};

export default withRouter(Display);
